Klient {{ ob | objectLabel: details.organizationClientId | async }} wybrał
produkty w
<a [routerLink]="['/lookbook/edit/', details.lookBookId, 'orders']"
  >LookBooku</a
  >
  za kwotę {{ details.amount | currency: details.currency }}
  <div class="thumbs items_count_{{ thumbs.length }}">
    @for (thumb of thumbs; track thumb; let i = $index) {
      <div (click)="showOrderDetails(i)" class="thumb">
        <img [src]="thumb | publicImageUrl: 500:500:'zalamo' | async" />
      </div>
    }
  </div>
